import React from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
} from "@coreui/react";

const metalData = [
  
];

const MetalPrice = () => {
  const isAllPricesEmpty = metalData.every(
    (item) => !item.price || item.price.trim() === ""
  );

  return (
    <div className="container-fluid px-3">
      <CRow className="mt-4 mb-3">
        <CCol>
          <h4 className="mb-0">Metal Prices</h4>
        </CCol>
      </CRow>

      <CCard>
        <CCardBody>
          <h5 className="mb-3">Metal</h5>
          <CTable responsive bordered hover>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell>Subcategory</CTableHeaderCell>
                <CTableHeaderCell>Metal Code</CTableHeaderCell>
                <CTableHeaderCell>Price (AUD)</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {metalData.map((item, idx) => (
                <CTableRow key={idx}>
                  <CTableDataCell>{item.subcategory || "-"}</CTableDataCell>
                  <CTableDataCell>{item.code || "-"}</CTableDataCell>
                  <CTableDataCell>
                    {item.price !== null &&
                    item.price !== undefined &&
                    item.price !== ""
                      ? `$${item.price}`
                      : "-"}
                  </CTableDataCell>
                </CTableRow>
              ))}
              {metalData.length === 0 && (
                <CTableRow>
                  <CTableDataCell
                    colSpan="3"
                    className="text-center text-muted"
                  >
                    No metals price data available.
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>

          {/* Show Coming Soon if all prices are missing */}
          {isAllPricesEmpty && (
            <div className="text-center text-warning mt-3">
              <strong>Coming soon...</strong>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default MetalPrice;
